// ./client/components/Reports/Controls.js
import React from "react";
import { useAppContext } from "../../context/appContext";
import { Checkbox, Input, Select } from "../../components/workspace";
import { BsFillGearFill } from "react-icons/bs";

function BusinessReports() {
	const { reports, lists, displayAlert, isLoading, handleChange, handleChanges } = useAppContext();

	const setDates = (newTerm) => {
		const today = new Date();
		const thirtyDaysAgo = new Date(today);
		let startDate = reports.startDate;

		if (Number(newTerm) < 5) {
			const termLength = lists?.listReportTerms.filter((item) => item.id === newTerm)[0].text;
			console.log("termLength:", termLength);
			thirtyDaysAgo.setDate(today.getDate() - Number(termLength));
			startDate = thirtyDaysAgo.toISOString().split("T")[0];
		}

		return startDate;
	};

	const handleInput = (e, isNumber) => {
		let startDate = reports.startDate;
		const property = e.target.name;
		const value = isNumber ? parseInt(e.target.value) : e.target.value;

		let newValues = { [property]: value };
		if (property === "reportTermsId") {
			startDate = setDates(value);
			newValues = { ...newValues, startDate };
		}
		if (property === "startDate" || property === "endDate") {
			// Change term length to custom if dates are altered
			newValues = { ...newValues, reportTermsId: 7 };
		}

		console.log("newValues:", newValues);
		handleChanges({
			baseObject: reports,
			baseName: "reports",
			newValues,
		});
	};

	const handleCheckBox = (e) => {
    const name = e.target.name;
    const value = e.target.checked; // grab checked instead of value
    handleChange({ baseObject: reports, name, value });
  };

	return (
		<div className="whole flex-parent">
			<div className="one-half flex-parent">
				<div className="whole">
					<Select
						name="reportTypesId"
						labelText="Report Type"
						handleChange={(e) => handleInput(e, true)} // designate isNumber as true
						value={reports.reportTypesId || "default"}
						options={lists && lists.listReportTypes}
					/>
				</div>
				<BsFillGearFill />
				<div className="one-third">
					<Checkbox 
					  name="reports.includeService"
					  labelText="Include Service Jobs"
					  checked={reports.includeService || false}
					  handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				<div className="one-third">
					<Checkbox 
					  name="reports.includeNewInstall"
					  labelText="Include New Install Jobs"
					  checked={reports.includeNewInstall || false}
					  handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				<div className="one-third">
					<Checkbox 
					  name="reports.includeCommercial"
					  labelText="Include Commercial Jobs"
					  checked={reports.includeCommercial || false}
					  handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
			</div>

			<div className="one-half flex-parent">
				<div className="whole">
					<Select
						name="reportTermsId"
						labelText="Term Length"
						handleChange={(e) => handleInput(e, true)} // designate isNumber as true
						value={reports.reportTermsId || "default"}
						options={lists && lists.listReportTerms}
					/>
				</div>
				<div className="one-half">
					<Input
						type="date"
						name="startDate"
						labelText="Report Start Date"
						value={reports.startDate || ""}
						handleChange={(e) => handleInput(e)}
					/>
				</div>
				<div className="one-half">
					<Input
						type="date"
						name="endDate"
						labelText="Report End Date"
						value={reports.endDate || ""}
						handleChange={(e) => handleInput(e)}
					/>
				</div>
			</div>
		</div>
	);
}

export default BusinessReports;
